var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconMonetizationUserLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 23.25H3.684m9.416-7.624a.936.936 0 0 1 .885-.626h8.328a.943.943 0 0 1 .76.38.9.9 0 0 1 .129.826L20.8 23.25H10.5Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.891 17.848a1 1 0 1 1-1 1 1 1 0 0 1 1-1M.75 23.25a6.757 6.757 0 0 1 8.758-6.45M3.945 8.781a6.858 6.858 0 0 0 7.643 1.536",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 10.875a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 1 0-8.25 0Zm15.75-8.625H16.5a1.341 1.341 0 0 0-.5 2.587l2.655.825a1.342 1.342 0 0 1-.5 2.588H15m2.25-6V.75m0 9v-1.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconMonetizationUserLaptop);
export default __webpack_public_path__ + "static/media/streamline-icon-monetization-user-laptop.5ac0e6f8.svg";
export { ForwardRef as ReactComponent };